import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes, SubmissionError } from 'redux-form';
import { required, email as isValidEmail } from '../../ReduxForm/validation';
import { ReduxFormField } from '../../ReduxForm/ReduxFormField';
import { ReduxFormSubmitButton } from '../../ReduxForm/ReduxFormSubmitButton';
import { noop } from '../../../utilities/functions';

import './styles.scss';
import { TOS_GENERAL_URL } from '../../../../constants';

const acceptTerms = (value) =>
  value ? undefined : 'You must agree to the terms of service';

class _SignUpForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    onSignUp: PropTypes.func.isRequired,
  };

  onSubmit = ({ email, password, fullName, subscribe }) => {
    const { onSignUp } = this.props;

    return new Promise((resolve, reject) => {
      onSignUp(email, password, fullName, subscribe, resolve, reject);
    }).then(noop, (errors) => {
      throw new SubmissionError(errors);
    });
  };

  render() {
    const { handleSubmit, submitting, error } = this.props;

    return (
      <div className="sign-up-form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            name="email"
            type="text"
            label="Email"
            component={ReduxFormField}
            validate={[required, isValidEmail]}
          />
          <Field
            name="password"
            type="password"
            label="Password"
            component={ReduxFormField}
            validate={required}
          />
          <Field
            name="fullName"
            type="text"
            label="Full name"
            component={ReduxFormField}
            validate={required}
          />

          <div className="checkbox-wrapper">
            <Field
              type="checkbox"
              name="terms"
              label={
                <span>
                  I agree to the{' '}
                  <a href={TOS_GENERAL_URL}>
                    <strong>terms of service</strong>
                  </a>
                </span>
              }
              component={ReduxFormField}
              validate={acceptTerms}
            />

            <Field
              type="checkbox"
              name="subscribe"
              label="Subscribe to our newsletter"
              component={ReduxFormField}
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <ReduxFormSubmitButton label="Start learning" {...{ submitting }} />
        </form>
      </div>
    );
  }
}

export const SignUpForm = reduxForm({
  form: 'signUp',
})(_SignUpForm);

export const ModalSignUpForm = reduxForm({
  form: 'modalSignUp',
})(_SignUpForm);
